<template>
    <ErrorPage>
        <template slot="Title">
            Error : Page Not found
        </template>
        <template slot="Content">
            Ooops... This page does not exist or has been removed.
        </template>
    </ErrorPage>
</template>

<script>
    import ErrorPage from './ErrorPage.vue'

    export default {
        name: 'Error404',
        components: { ErrorPage }
    }
</script>

<style scoped>
</style>